export default __webpack_public_path__ + "img/bangkok_music_city-8c312c43ff98f20d833a867cc8b306f0.png";